module.exports = __webpack_public_path__ + "img/Uptick_IRIS3o.fdd2589e.png";